import { Button } from 'avo-ui'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'
import icFilter from 'assets/images/ic-filter.svg'
import Select from 'components/commons/select'
import CheckboxList from 'components/commons/checkbox-list'
import ModalAdvanceFilter from 'components/commons/modal-advance-filter'

export const AdvanceFilter = ({
    show,
    setShow,
    filterDetail,
    getFilterCount,
    onSearchVoucher,
    onChangeForm,
    onClear,
    options,
    onSubmit,
}) => {
    return (
        <div>
            <div className={'w-fit relative'}>
                <Button
                    className={clsx(getFilterCount() > 0 && '!bg-blue-90 !text-white')}
                    title={'Filter'}
                    icon={getFilterCount() > 0 ? icFilterWhite : icFilter}
                    type={'outline'}
                    onClick={() => setShow(!show)}
                />
                <div
                    className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${getFilterCount() > 0 ? 'block' : 'hidden'}`}
                >
                    {getFilterCount()}
                </div>
            </div>
            <ModalAdvanceFilter
                className={'!w-[850px]'}
                classNameContent={'!max-h-[500px] overflow-auto'}
                show={show}
                onHide={() => setShow(false)}
                title={'Filter'}
                onClear={onClear}
                onSubmit={() => onSubmit(filterDetail)}
            >
                <div className={'flex space-x-16 px-8 py-2 mb-2'}>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Voucher</div>
                            <Select
                                name={'voucher_codes'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih voucher'}
                                options={options?.voucher_codes}
                                value={filterDetail?.voucher_codes}
                                searchable
                                isMultiple
                                onChange={onChangeForm}
                                onSearch={onSearchVoucher}
                            />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Payment Method</div>
                            <CheckboxList
                                className={'flex-1'}
                                name={'Payment Method'}
                                options={options?.payment_services}
                                values={filterDetail?.payment_services}
                                onChange={(value) => onChangeForm({ name: 'payment_services', value })}
                            />
                        </div>
                    </div>
                    <div className={'flex-1 flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Filter by Shipping Method</div>
                        <CheckboxList
                            className={'flex-1'}
                            name={'Shipping Method'}
                            options={options?.shipping_aliases}
                            values={filterDetail?.shipping_aliases}
                            onChange={(value) => onChangeForm({ name: 'shipping_aliases', value })}
                        />
                    </div>
                </div>
            </ModalAdvanceFilter>
        </div>
    )
}
